export function calculateFontSize(sizeString: string | null): string | null {
  if (!sizeString) {
    return null;
  }
  const size = Number(sizeString);
  const vw = ((size * 100) / 1920).toFixed(10);
  return `min(${vw}vw, ${size}px)`;
}

// Rozmiar z panelu jest podany dla desktopu (XD 1920). Na mobile (XD 390) projekt używa
// mniejszej skali — 45 z panelu = 33px w makiecie, stąd współczynnik 33/45. Trzymamy go w jednym
// miejscu, żeby proporcja header1 : header2 z panelu przenosiła się też na telefon
// (wcześniej mobile miało zaszyte na sztywno 33px i 16px, więc ustawienia z panelu nic nie robiły).
const MOBILE_FONT_SIZE_SCALE = 33 / 45;
const XD_MOBILE_PAGE_WIDTH = 390;
const MOBILE_MIN_PAGE_WIDTH = 250;

/**
 * Odpowiednik funkcji SCSS `convertFromPxToVwMobile()` — skaluje rozmiar z szerokością ekranu,
 * z podłogą na 250px szerokości.
 */
export function calculateMobileFontSize(sizeString: string | null): string | null {
  if (!sizeString) {
    return null;
  }
  const size = Number(sizeString) * MOBILE_FONT_SIZE_SCALE;
  const vw = ((size * 100) / XD_MOBILE_PAGE_WIDTH).toFixed(4);
  const min = ((size * MOBILE_MIN_PAGE_WIDTH) / XD_MOBILE_PAGE_WIDTH).toFixed(4);
  return `max(${vw}vw, ${min}px)`;
}
